import { Ref, HidingContentSwitcher } from "@tblabs/truffle";
import { BasketItemType } from "../../Models/Basket/BasketItemType";
import { Product } from "../../Models/Product/Product";
import { Basket } from "../../Services/Basket/Basket";
import { Box } from "./Components/Box";
import { ProductInfoBox } from "./Components/ProductInfoBox";
import { RentOrSaleBox } from "./Components/RentOrSaleBox";
import { RentBox } from "./RentBox";
import { SaleBox, ServiceBox } from "./SaleBox";


export class ProductActionsBox extends Box
{
    constructor(product: Product, basket: Basket, productOptionId: Ref<string>)
    {
        const rentOrSale = new Ref<BasketItemType>(BasketItemType.Rent).Storable("rentOrSale");
        const switcher = new HidingContentSwitcher(rentOrSale);

        if (product.Rentable.value)
            switcher.AddContent(BasketItemType.Rent, () => new RentBox(product, basket, productOptionId));

        if (product.Saleable.value)
            switcher.AddContent(BasketItemType.Sale, () => new SaleBox(product, basket, productOptionId));

        super("panel-dark product__actions", [
            new RentOrSaleBox(product, rentOrSale),
            switcher,
            (!product.Rentable.value && !product.Saleable.value) && new ServiceBox(product, basket, productOptionId),
            product.ShowExtraInfo.value && new ProductInfoBox(),
        ]);

        this.Class("product__form");
    }
}
